// removed by extract-text-webpack-plugin
module.exports = {"goal-step":"goal-step","subtitle":"subtitle","options":"options","option":"option","option-text":"option-text","selected":"selected","btn-primary":"btn-primary"};


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/conversion-quiz/steps/goal/goal.style.sass
// module id = zApV
// module chunks = 1